import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MDIconComponent } from '@melodic-ui/components';
import { LESSON_STATUS_CONFIG, LessonStatusType } from '../utils/lesson-status-config';

@Component({
	selector: 'lb-lesson-status-legend',
	standalone: true,
	imports: [CommonModule, MDIconComponent],
	templateUrl: './lesson-status-legend.component.html',
	styleUrl: './lesson-status-legend.component.scss'
})
export class LessonStatusLegendComponent {
	protected readonly statusConfig = LESSON_STATUS_CONFIG;
	protected readonly statuses: LessonStatusType[] = [
		'scheduled',
		'completed',
		'absent',
		'reschedule',
		'awaiting-payment',
		'missing-attendance'
	];
}
